import { permitContainerPlacementDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getpermitContainerPlacementEn = () => {
  const data = permitContainerPlacementDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addpermitContainerPlacement = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/do-you-need-a-permit-for-your-container-placement`,
    ) &&
    document.getElementById(`permitContainerPlacementJSONLD`) === null
  ) {
    const script = permitContainerPlacementJSONLDEn()
    addJSONLDToHead(script, `permitContainerPlacementJSONLD`)
  } else {
    removeElement(`permitContainerPlacementJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const permitContainerPlacementJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getpermitContainerPlacementEn(),
  }
  return FaqBagsterTemplate
}
